import { IPGRBreedModel, ISpeciesModel, IIdexxBreedModel, PGRBreedModel, SpeciesModel, IdexxBreedModel } from ".";
import { defaultTo } from "lodash";
import { IModel, Model, ModelRecord, } from "./Model";

export interface IBreedModel extends IModel {
    breedId: number;
    name: string;
    speciesId: number;
    species: ISpeciesModel;
    pgrBreed: IPGRBreedModel;
    pgrBreedId: number;
    idexxBreedId: number;
    idexxBreed: IIdexxBreedModel;
}

export class BreedModel extends Model implements ModelRecord<IBreedModel> {
    breedId: number;
    name: string;
    speciesId: number;
    species: SpeciesModel;
    pgrBreedId: number;
    pgrBreed: PGRBreedModel;
    idexxBreedId: number;
    idexxBreed: IdexxBreedModel;

    constructor(params?: Partial<IBreedModel>) {
        super(params);
        this.breedId = defaultTo(params?.breedId, 0);
        this.name = defaultTo(params?.name, '');
        this.speciesId = defaultTo(params?.speciesId, 0);
        this.species = params?.species ? new SpeciesModel(params.species) : new SpeciesModel();
        this.pgrBreedId = defaultTo(params?.pgrBreedId, 0);
        this.pgrBreed = params?.pgrBreed ? new PGRBreedModel(params.pgrBreed) : new PGRBreedModel();
        this.idexxBreedId = defaultTo(params?.idexxBreedId, 0);
        this.idexxBreed = params?.idexxBreed ? new IdexxBreedModel(params.idexxBreed) : new IdexxBreedModel();
    }
}
